<template>
  <div class="toast" v-show="isToastShow">
    <div class="alert_box" :class="{'fadeInUp': showIn, 'fadeOut': !showIn}">
      <p class="alert">{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'toast',
  data () {
    return {
    };
  },
  computed: {
    showIn () {
      return this.$store.state.toast.showIn;
    },
    isToastShow () {
      return this.$store.state.toast.show;
    },
    message () {
      return this.$store.state.toast.message;
    }
  }
};
</script>

<style lang="scss">
  .toast {
    position: fixed;
    left: 50%;
    top: 46%;
    width: 80vw;
    text-align: center;
    transform: translate(-50%, -50%);
    animation-duration: .5s;
    z-index: 999;
    .alert_box {
      display: inline-block;
      background: rgba(0, 0, 0, 0.8);
      box-shadow: 1Px 1Px 5px 1Px #8a9dac;
      border-radius: 5px;
      animation-duration: 0.8s;
      color: #fff;
    }
    .alert {
      display: inline-block;
      min-width: 200px;
      padding: 20px 35px;
      margin: 0 auto;
      font-size: 28px;
      line-height: 50px;
    }
  }
</style>
